module.exports = __webpack_public_path__ + "images/category_lp/bike/new/assessment_achievements/3_2a650e4956c2e5e14cc265e2c48cc8bf.png";